import React from "react";
import styled from "styled-components";
import { Card, Empty, Progress, Space, Tag, Typography } from "antd";

const { Text } = Typography;

const WidgetCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 100%;

  .ant-card-head-title {
    color: #005249;
    font-weight: 700;
  }
`;

const RouteList = styled.div`
  display: grid;
  gap: 12px;
`;

const RouteRow = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px;
`;

const RouteHeader = styled(Space)`
  width: 100%;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const RouteVolumeWidget = ({ routeVolume }) => {
  if (!routeVolume?.routes?.length) {
    return (
      <WidgetCard title="Route Volume">
        <Empty
          description="No route volume data for the selected filters"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </WidgetCard>
    );
  }

  const maxTrips = Math.max(
    ...routeVolume.routes.map((route) => Number(route.tripCount || 0)),
    1
  );

  return (
    <WidgetCard
      title="Route Volume"
      extra={<Tag color="blue">{routeVolume.routes.length} routes</Tag>}
      data-testid="route-volume-widget"
    >
      <RouteList>
        {routeVolume.routes.map((route) => (
          <RouteRow key={route.drilldownKey} data-drilldown-key={route.drilldownKey}>
            <RouteHeader>
              <Text strong ellipsis={{ tooltip: route.label }}>
                {route.label}
              </Text>
              <Text>{formatNumber(route.tripCount)} trips</Text>
            </RouteHeader>
            <Progress
              percent={Math.round((Number(route.tripCount || 0) / maxTrips) * 100)}
              showInfo={false}
              strokeColor="#005249"
            />
            <Tag color={route.activeTripCount > 0 ? "green" : "default"}>
              {formatNumber(route.activeTripCount)} active
            </Tag>
          </RouteRow>
        ))}
      </RouteList>
    </WidgetCard>
  );
};

function formatNumber(value) {
  return new Intl.NumberFormat("en-ZA").format(Number(value || 0));
}

export default RouteVolumeWidget;
